import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { EnumMenuAcoes } from "./Cards";
import "./style.css";
import { Projeto } from "./types";
import adminStore from "src/store/AdminStore";


export enum TipoExibicao {
  PADRAO = "acao-popover-element",
  DESATIVO = "acao-popover-element-desativo",
  NAO_EXIBIR = "acao-popover-element-hidden",
}

export interface MenuAcao { 
  id: EnumMenuAcoes, 
  titulo: string,
  handleOpenAcao?: Function,
  projetoId?: number,
  codigoVenda?: string,
  exibicao?: TipoExibicao,
  status_projeto?: string,
  projeto?: Projeto
  acaoDesabilitadaTooltip?: string
}

export default function MenuItemAcao(menuAcao: MenuAcao) {

  const handleClick = () => {
    if (menuAcao?.projetoId) {
      adminStore.buscarProjeto(menuAcao?.projetoId, true).then((resp) => {
        if (resp?.length && menuAcao?.handleOpenAcao) {
          menuAcao.handleOpenAcao(menuAcao);
        }
      });
    } else if (menuAcao && menuAcao.handleOpenAcao) {
      menuAcao?.handleOpenAcao(menuAcao);
    }
  };
  const [tipoExibicao, setTipoExibicao] = useState<TipoExibicao>(TipoExibicao.PADRAO);

  useEffect(() => {
    if (menuAcao && menuAcao?.exibicao) {
      setTipoExibicao(menuAcao.exibicao);
    }
  }, [menuAcao]);

  if (tipoExibicao === TipoExibicao.DESATIVO) {
    return (
      <Tooltip title={menuAcao.acaoDesabilitadaTooltip || ""}>
        <span>
          <div onClick={handleClick} className={tipoExibicao}>
            <div className='acao-titulo'>{menuAcao.titulo}</div>
          </div>
        </span>
      </Tooltip>
    )
  }

  return (
      <div onClick={handleClick} className={tipoExibicao}>
        <div className='acao-titulo'>{menuAcao.titulo}</div>
      </div>
  );
}
